import {
  StyleParamType,
  wixColorParam,
  wixFontParam,
  createStylesParams,
} from '@wix/tpa-settings';
import { StyleType } from '@wix/editor-platform-ooi-metadata-resolver';
import DefaultDesign from '../../design';

const defaultDesign = DefaultDesign;
export type IFaqOoiStylesParams = {
  headerTextColor: StyleParamType.Color;
  headerTextFont: StyleParamType.Font;
  selectedCategoryColor: StyleParamType.Color;
  categoryOtherTextColor: StyleParamType.Color;
  categoryOtherTextFont: StyleParamType.Font;
  widgetColor: StyleParamType.Color;
  questionTextColor: StyleParamType.Color;
  questionTextFont: StyleParamType.Font;
  questionStripesTextColor: StyleParamType.Color;
  questionStripesTextFont: StyleParamType.Font;
  questionNumberTextColor: StyleParamType.Color;
  questionNumberTextFont: StyleParamType.Font;
  questionNumberHoverColor: StyleParamType.Color;
  questionNumberBgColor: StyleParamType.Color;
  answerTextColor: StyleParamType.Color;
  answerTextFont: StyleParamType.Font;
  answersLinksColor: StyleParamType.Color;
  dividerCollapseColor: StyleParamType.Color;
  numberQuestionsLayoutBorderColor: StyleParamType.Color;
  numberQuestionsLayoutBorderWidth: StyleParamType.Number;
  numberAnswersLayoutBorderColor: StyleParamType.Color;
  numberAnswersLayoutBorderWidth: StyleParamType.Number;
  numberAnswersLayoutBgColor: StyleParamType.Color;
  showFAQCategories: StyleParamType.Boolean;
  showTitle: StyleParamType.Boolean;
  showSearchBar: StyleParamType.Boolean;
  showSocialIcons: StyleParamType.Boolean;
  showFacebookIcon: StyleParamType.Boolean;
  showTwitterIcon: StyleParamType.Boolean;
  showLinkedinIcon: StyleParamType.Boolean;
  showCopyQuestionLink: StyleParamType.Boolean;
};

export const stylesParams = createStylesParams<IFaqOoiStylesParams>({
  headerTextColor: {
    type: StyleParamType.Color,
    key: defaultDesign.headerText.color.name,
    getDefaultValue: wixColorParam(defaultDesign.headerText.color.value),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.headerText.color.value,
      },
    },
  },

  headerTextFont: {
    type: StyleParamType.Font,
    key: defaultDesign.headerText.font.name,
    inheritDesktop: true,
    getDefaultValue: ({ isMobile, textPresets }) =>
      wixFontParam(defaultDesign.headerText.font.value, {
        size: isMobile
          ? defaultDesign.headerText.font.startWithMobileSize
          : defaultDesign.headerText.font.startWithSize,
        htmlTag: defaultDesign.headerText.font.htmlTag,
      })({ textPresets }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        // htmlTag: defaultDesign.headerText.font.htmlTag,
        preset: defaultDesign.headerText.font.value,
        size: defaultDesign.headerText.font.startWithSize,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: defaultDesign.headerText.font.value,
        size: defaultDesign.headerText.font.startWithMobileSize,
      },
    },
  },
  selectedCategoryColor: {
    type: StyleParamType.Color,
    key: defaultDesign.selectedCategory.color.name,
    getDefaultValue: wixColorParam(
      defaultDesign.selectedCategory.color.value,
      defaultDesign.selectedCategory.color.opacity || 1,
    ),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.selectedCategory.color.value,
        opacity: defaultDesign.selectedCategory.color.opacity || 1,
      },
    },
  },
  categoryOtherTextColor: {
    type: StyleParamType.Color,
    key: defaultDesign.categoryOtherText.color.name,
    getDefaultValue: wixColorParam(defaultDesign.categoryOtherText.color.value),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.categoryOtherText.color.value,
      },
    },
  },
  categoryOtherTextFont: {
    type: StyleParamType.Font,
    key: defaultDesign.categoryOtherText.font.name,
    getDefaultValue: wixFontParam(defaultDesign.categoryOtherText.font.value, {
      size: defaultDesign.categoryOtherText.font.startWithSize,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.categoryOtherText.font.value,
        size: defaultDesign.categoryOtherText.font.startWithSize,
      },
    },
  },
  widgetColor: {
    type: StyleParamType.Color,
    key: defaultDesign.widget.color.name,
    getDefaultValue: wixColorParam(
      defaultDesign.widget.color.value,
      defaultDesign.widget.color.opacity || 1,
    ),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.widget.color.value,
        opacity: defaultDesign.widget.color.opacity || 1,
      },
    },
  },
  questionTextColor: {
    type: StyleParamType.Color,
    key: defaultDesign.questionText.color.name,
    getDefaultValue: wixColorParam(defaultDesign.questionText.color.value),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.questionText.color.value,
      },
    },
  },
  questionTextFont: {
    type: StyleParamType.Font,
    key: defaultDesign.questionText.font.name,
    getDefaultValue: ({ isMobile, textPresets }) =>
      wixFontParam(defaultDesign.questionText.font.value, {
        lineHeight: defaultDesign.questionText.font.lineHeight,
        size: isMobile
          ? defaultDesign.questionText.font.startWithMobileSize
          : defaultDesign.questionText.font.startWithSize,
        htmlTag: defaultDesign.questionText.font.htmlTag,
      })({ textPresets }),

    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.questionText.font.value,
        size: defaultDesign.questionText.font.startWithSize,
        // lineHeight: defaultDesign.questionText.font.lineHeight,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: defaultDesign.questionText.font.value,
        size: defaultDesign.questionText.font.startWithMobileSize,
        // lineHeight: defaultDesign.questionText.font.lineHeight,
      },
    },
  },
  questionStripesTextColor: {
    type: StyleParamType.Color,
    key: defaultDesign.questionStripesText.color.name,
    getDefaultValue: wixColorParam(
      defaultDesign.questionStripesText.color.value,
    ),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.questionStripesText.color.value,
      },
    },
  },
  questionStripesTextFont: {
    type: StyleParamType.Font,
    key: defaultDesign.questionStripesText.font.name,
    getDefaultValue: wixFontParam(defaultDesign.questionStripesText.font.value),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.questionStripesText.font.value,
        // htmlTag: defaultDesign.questionStripesText.font.htmlTag,
        size: defaultDesign.questionStripesText.font.startWithSize,
      },
    },
  },
  questionNumberTextColor: {
    type: StyleParamType.Color,
    key: defaultDesign.questionNumberText.color.name,
    getDefaultValue: wixColorParam(
      defaultDesign.questionNumberText.color.value,
    ),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.questionNumberText.color.value,
      },
    },
  },
  questionNumberTextFont: {
    type: StyleParamType.Font,
    key: defaultDesign.questionNumberText.font.name,
    getDefaultValue: ({ isMobile, textPresets }) =>
      wixFontParam(defaultDesign.questionNumberText.font.value, {
        size: isMobile
          ? defaultDesign.questionNumberText.font.startWithMobileSize
          : defaultDesign.questionNumberText.font.startWithSize,
      })({ textPresets }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.questionNumberText.font.value,
        size: defaultDesign.questionNumberText.font.startWithSize,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: defaultDesign.questionNumberText.font.value,
        size: defaultDesign.questionNumberText.font.startWithMobileSize,
      },
    },
  },
  questionNumberHoverColor: {
    type: StyleParamType.Color,
    key: defaultDesign.questionNumberHover.color.name,
    getDefaultValue: wixColorParam(
      defaultDesign.questionNumberHover.color.value,
      defaultDesign.questionNumberHover.color.opacity || 1,
    ),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.questionNumberHover.color.value,
        opacity: defaultDesign.questionNumberHover.color.opacity || 1,
      },
    },
  },
  questionNumberBgColor: {
    type: StyleParamType.Color,
    key: defaultDesign.questionNumberBgColor.color.name,
    getDefaultValue: wixColorParam(
      defaultDesign.questionNumberBgColor.color.value,
      defaultDesign.questionNumberBgColor.color.opacity || 1,
    ),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.questionNumberBgColor.color.value,
        opacity: defaultDesign.questionNumberBgColor.color.opacity || 1,
      },
    },
  },
  numberQuestionsLayoutBorderColor: {
    type: StyleParamType.Color,
    key: defaultDesign.numberQuestionsLayoutBorder.color.name,
    getDefaultValue: wixColorParam(
      defaultDesign.numberQuestionsLayoutBorder.color.value,
      defaultDesign.numberQuestionsLayoutBorder.color.opacity || 0.75,
    ),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.numberQuestionsLayoutBorder.color.value,
      },
    },
  },

  numberQuestionsLayoutBorderWidth: {
    type: StyleParamType.Number,
    key: defaultDesign.numberQuestionsLayoutBorder.border.name,
    getDefaultValue: () =>
      defaultDesign.numberQuestionsLayoutBorder.border.value,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: defaultDesign.numberQuestionsLayoutBorder.border.value,
      },
    },
  },
  numberAnswersLayoutBgColor: {
    type: StyleParamType.Color,
    key: defaultDesign.numberAnswersLayoutBgColor.name,
    getDefaultValue: wixColorParam(
      defaultDesign.numberAnswersLayoutBgColor.value,
      defaultDesign.numberAnswersLayoutBgColor.opacity,
    ),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.numberAnswersLayoutBgColor.value,
        opacity: defaultDesign.numberAnswersLayoutBgColor.opacity || 1,
      },
    },
  },
  numberAnswersLayoutBorderColor: {
    type: StyleParamType.Color,
    key: defaultDesign.numberAnswersLayoutBorder.color.name,
    getDefaultValue: wixColorParam(
      defaultDesign.numberAnswersLayoutBorder.color.value,
      defaultDesign.numberAnswersLayoutBorder.color.opacity || 0.75,
    ),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.numberAnswersLayoutBorder.color.value,
        opacity: defaultDesign.numberAnswersLayoutBorder.color.opacity || 0.75,
      },
    },
  },
  numberAnswersLayoutBorderWidth: {
    type: StyleParamType.Number,
    key: defaultDesign.numberAnswersLayoutBorder.border.name,
    getDefaultValue: () => defaultDesign.numberAnswersLayoutBorder.border.value,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: defaultDesign.numberAnswersLayoutBorder.border.value,
      },
    },
  },
  answerTextColor: {
    type: StyleParamType.Color,
    key: defaultDesign.answerText.color.name,
    getDefaultValue: wixColorParam(defaultDesign.answerText.color.value),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.answerText.color.value,
      },
    },
  },
  answerTextFont: {
    type: StyleParamType.Font,
    key: defaultDesign.answerText.font.name,
    getDefaultValue: wixFontParam(defaultDesign.answerText.font.value, {
      size: defaultDesign.answerText.font.startWithSize,
      lineHeight: defaultDesign.answerText.font.lineHeight,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.answerText.font.value,
        size: defaultDesign.answerText.font.startWithSize,
        // lineHeight: defaultDesign.answerText.font.lineHeight,
      },
    },
  },
  answersLinksColor: {
    type: StyleParamType.Color,
    key: defaultDesign.answersLinks.color.name,
    getDefaultValue: wixColorParam(defaultDesign.answersLinks.color.value),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.answersLinks.color.value,
      },
    },
  },
  dividerCollapseColor: {
    type: StyleParamType.Color,
    key: defaultDesign.dividerCollapse.color.name,
    getDefaultValue: wixColorParam(
      defaultDesign.dividerCollapse.color.value,
      defaultDesign.dividerCollapse.color.opacity || 1,
    ),

    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: defaultDesign.dividerCollapse.color.value,
        opacity: defaultDesign.dividerCollapse.color.opacity || 1,
      },
    },
  },
  showTitle: {
    type: StyleParamType.Boolean,
    key: 'showTitle',
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showSearchBar: {
    type: StyleParamType.Boolean,
    key: 'showSearchBar',
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showSocialIcons: {
    type: StyleParamType.Boolean,
    key: 'showSocialIcons',
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showFacebookIcon: {
    type: StyleParamType.Boolean,
    key: 'showFacebookIcon',
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showTwitterIcon: {
    type: StyleParamType.Boolean,
    key: 'showTwitterIcon',
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showLinkedinIcon: {
    type: StyleParamType.Boolean,
    key: 'showLinkedinIcon',
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showCopyQuestionLink: {
    type: StyleParamType.Boolean,
    key: 'showCopyQuestionLink',
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showFAQCategories: {
    type: StyleParamType.Boolean,
    key: 'showFAQCategories',
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
});

export default stylesParams;
